import React, { useState } from "react";
import { Button, Form } from "antd";
import styled from "styled-components";
import GridBuilder from "../../UIBuilderEngine/GridBuilder";
import ReusableDrawer from "../../Reusablecomponents/ReusableDrawer";

const CreateWrap = styled.div`
  .Create {
    background-color: #2c963d;
    color: white;
    font-size: 16px;
    font-weight: 500;
    padding: 10px 20px;
    border-radius: 26px;
    cursor: pointer;
    width: 112px;
    height: 38px;
    padding: 9px 16px;
    border: 1px solid transparent;
    position: absolute;
    right: 16px;
    top: 66px;

    &:focus,
    &:active {
      outline: none;
      border-color: transparent;
    }
  }

  .custom-drawer {
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
  }
`;

const MasterCreate = () => {
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    code: "",
    name: "",
    email: "",
    phone: "",
    emeremail: "",
    emerphone: "",
    contperson: "",
    designation: "",
    address: "",
  });

  const showDrawer = () => {
    setOpen(true);
  };

  const handleOk = () => {
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmitForm = () => {
    setOpen(false);
  };

  const AddEditForm = {
    totalpages: 1,
    pages: [
      {
        modalView: false,
        colSpan: [24, 24, 24],
        fields: [
          // First Row (4 Fields)
          [
            {
              id: 1,
              label: <span style={{ color: "red" }}>Company Code</span>,
              type: "text",
              name: "code",
              placeholder: "Enter Company Code",
              value: formData.code,
              onChange: handleChange,
              maxLength: 50,

              validationRules: [
                { required: true, message: "Company Code is required" },
              ],
            },
            {
              id: 2,
              label: "Company Name",
              type: "text",
              name: "name",
              placeholder: "Enter Company Name",
              value: formData.name,
              onChange: handleChange,
              maxLength: 50,

              validationRules: [
                { required: true, message: "Company Name is required" },
              ],
            },
            {
              id: 3,
              label: "Email",
              type: "email",
              name: "email",
              placeholder: "Enter your email",
              value: formData.email,
              onChange: handleChange,
              maxLength: 50,
              // style: fieldStyle,
              validationRules: [
                { required: true, message: "Email is required" },
              ],
            },
            {
              id: 4,
              label: "Phone",
              type: "number",
              name: "phone",
              placeholder: "Enter Phone number",
              value: formData.phone,
              onChange: handleChange,
              maxLength: 10,
              // style: fieldStyle,
              validationRules: [
                { required: true, message: "Phone number is required" },
                {
                  pattern: /^[0-9]+$/,
                  message: "Phone number must be a valid number",
                },
              ],
            },
          ],
          // Second Row (4 Fields)
          [
            {
              id: 5,
              label: "Emergency Email",
              type: "email",
              name: "emeremail",
              placeholder: "Enter Emergency email",
              value: formData.emeremail,
              onChange: handleChange,
              disabled: false,
              // style: fieldStyle,
            },
            {
              id: 6,
              label: "Emergency Phone",
              type: "text",
              name: "emerphone",
              placeholder: "Enter Emergency Phone",
              value: formData.emerphone,
              onChange: handleChange,
              // style: fieldStyle,
              validationRules: [
                {
                  pattern: /^[0-9]+$/,
                  message: "Phone number must be a valid number",
                },
              ],
            },
            {
              id: 7,
              label: "Contact Person",
              type: "text",
              name: "contperson",
              placeholder: "Enter Contact Person",
              value: formData.contperson,
              onChange: handleChange,
              // style: fieldStyle,
            },
            {
              id: 8,
              label: "Designation",
              type: "text",
              name: "designation",
              placeholder: "Enter Designation",
              value: formData.designation,
              onChange: handleChange,
              // style: fieldStyle,
            },
          ],
          // Address Row
          [
            {
              id: 9,
              label: "Address",
              type: "textarea",
              name: "address",
              placeholder: "Enter Address",
              value: formData.address,
              onChange: handleChange,
              // style: textAreaStyle,
            },
          ],
        ],
      },
    ],
  };

  return (
    <CreateWrap>
      <Button type="primary" className="Create" onClick={showDrawer}>
        + Create
      </Button>
      <ReusableDrawer
        title="Creating Master Company"
        open={open}
        setOpen={setOpen}
        onOk={handleSubmitForm}
        onCancel={handleCancel}
        footer={[
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <Button
              key="cancel"
              className="cancel-btn"
              onClick={handleCancel}
              style={{
                borderRadius: "26px",
                backgroundColor: "#E8FFEC",
                color: "#2C963D",
                borderColor: "#E8FFEC",
                width: "118px",
                height: "38px",
              }}
            >
              Cancel
            </Button>
            ,
            <Button
              key="create"
              type="primary"
              onClick={handleSubmitForm}
              style={{
                backgroundColor: "#2C963D",
                borderRadius: "26px",
                borderColor: "#2C963D",
                width: "118px",
                height: "38px",
              }}
            >
              Create
            </Button>
          </div>,
        ]}
        children={
          <GridBuilder
            formStructureJson={AddEditForm}
            handleChange={handleChange}
            formSubmit={handleSubmitForm}
            initialValues={formData}
            form={form}
          />
        }
      />
    </CreateWrap>
  );
};

export default MasterCreate;
